import {
  PermissionsInfoModel as Data,
  PermissionsInfoModelCollection as Collection,
} from '@/typings/api/PermissionsInfoModel'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class PermissionsInfoModelsApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'permissions/info-models';
}
